<template>

  <div>
    <v-text-field v-model="asset.name" :label="$t('assets.name')" :disabled="readonly" data-test="asset-name" />

    <asset-autocomplete v-model="asset.parentId" :label="$tc('assets.parent', 1)" :disabled="readonly" :clearable="true" />

    <div class="row" v-if="$can('admin')">
      <device-types-select class="col-md-6" v-model="asset.deviceType" :label="$t('devices.type')" :disabled="readonly" data-test="device-type" />
      <asset-type-autocomplete class="col-md-6" v-model="asset.assetTypeId" :label="$tc('asset-types.entity-name', 1)" :disabled="readonly" data-test="asset-type" />
    </div>
  </div>

</template>

<script>
  import AssetAutocomplete from '../asset-autocomplete'
  import DeviceTypesSelect from '../../devices/device-types-select'
  import AssetTypeAutocomplete from '../../asset-types/asset-type-autocomplete'

  export default {
    name: 'asset-form-core',

    props: [ 'asset', 'readonly' ],

    components: {
      AssetTypeAutocomplete,
      DeviceTypesSelect,
      AssetAutocomplete
    },
  }
</script>

<style scoped lang="scss">

</style>
